import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

const TransparentTooltip = withStyles({
  tooltip: { backgroundColor: "transparent", fontSize: "0.8rem" },
})(Tooltip);

export default TransparentTooltip;
